import Vue from 'vue';
import ModalWrapper from './modal/ModalWrapper';
import FacebookLogin from './modal/FacebookLogin';
import ShareCompany from './modal/ShareCompany';
import FollowPopularCompany from './modal/FollowPopularCompany';

/**
 * フェイスブックへのログイン誘導モーダル
 */
const vmFacebookLoginModal = new Vue({
  components: { ModalWrapper, FacebookLogin },
  template: `<ModalWrapper :is-show-props="isShow" :is-close-button-props="false" @closeModal="closeModal">
    <template v-slot:content>
      <FacebookLogin @closeModal="closeModal" />
    </template>
  </ModalWrapper>`,
  data: function () {
    return {
      isShow: false
    };
  },
  methods: {
    closeModal: function () {
      this.isShow = false;
    }
  }
});

/**
 * フォロー後のシェア誘導モーダル
 */
const vmFacebookShareModal = new Vue({
  components: { ModalWrapper, ShareCompany },
  template: `<ModalWrapper :is-show-props="isShow" @closeModal="closeModal">
    <template v-slot:content>
      <ShareCompany :company-id-props.sync="companyId" :company-name-props.sync="companyName" @closeModal="closeModal"/>
    </template>
  </ModalWrapper>`,
  data: function () {
    return {
      isShow: false,
      companyId: 0,
      companyName: ''
    };
  },
  methods: {
    closeModal: function () {
      this.isShow = false;
    }
  }
});

/**
 * 人気企業をフォロー後、他企業フォローへの誘導モーダル
 */
const vmFollowPopularCompany = new Vue({
  components: { ModalWrapper, FollowPopularCompany },
  template: `<ModalWrapper :is-show-props="isShow" @closeModal="closeModal">
    <template v-slot:content>
      <FollowPopularCompany :data-list-props.sync="dataList" @spliceDataList="spliceDataList" @closeModal="closeModal"/>
    </template>
  </ModalWrapper>
  `,
  data: function () {
    return {
      isShow: false,
      dataList: []
    };
  },
  methods: {
    spliceDataList: function (index) {
      this.dataList = this.dataList.filter((_, i) => i !== index);
      if (this.dataList.length === 0) {
        this.isShow = false;
      }
    },
    closeModal: function () {
      this.isShow = false;
      this.dataList = [];
    }
  }
});

export {
  vmFacebookLoginModal,
  vmFacebookShareModal,
  vmFollowPopularCompany
};
